import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLeaf, FaBroom, FaSwimmingPool } from "react-icons/fa";

function SelectCategory() {
  const navigate = useNavigate();

  const go = (category) => {
    navigate(`/select-type/${category}`);
  };

  return (
    <div style={styles.container}>
      <h2>SELECT A CATEGORY</h2>
      <p>Choose the industry for your listing</p>

      <div style={styles.stack}>
        <div style={{ ...styles.card, background: "#2e7d32" }} onClick={() => go("mowing")}>
  <FaLeaf size={46} /> Lawn Mowing
</div>

<div style={{ ...styles.card, background: "#2e7d32" }} onClick={() => go("cleaning")}>
  <FaBroom size={46} /> Cleaning
</div>

<div style={{ ...styles.card, background: "#2e7d32" }} onClick={() => go("pool")}>
  <FaSwimmingPool size={46} /> Pool Care
</div>

      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: 500,
    margin: "40px auto",
    padding: 20,
    textAlign: "center",
  },
  stack: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
    marginTop: 30,
  },
  card: {
    color: "#fff",
    borderRadius: 14,
    padding: "28px 20px",
    fontSize: 20,
    fontWeight: 600,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
  },
};

export default SelectCategory;
